import { Typography, useTheme } from '@mui/material';

type Props = {
  children: string;
};
export const TitleDescription = ({ children }: Props) => {
  const theme = useTheme();
  const greyColor = theme.palette.grey[500];
  return (
    <Typography sx={{ fontSize: '14px', fontWeight: 700, color: greyColor }}>{children}</Typography>
  );
};
